import { css } from '@emotion/css';
import * as React from 'react';

import LargeHeading from 'components/LargeHeading';

const wrapper = css({
  marginTop: '1.875rem',
  flex: '1',
  overflow: 'hidden',
  paddingLeft: '1.25rem',
  paddingRight: '1.25rem',
  '@media (min-width: 768px and max-width: 1279px)': {
    paddingRight: '5px',
    paddingLeft: '0px',
  },
  '@media (min-width: 1280px)': {
    marginLeft: '1.875rem',
  },
});

const headerWrapper = css({
  display: 'flex',
  flexDirection: 'row',
  marginBottom: '1.5rem',
});

const heading = css({
  flex: 1,
});

interface Props {
  children: React.ReactNode;
  headerRight?: React.ReactNode;
}

const GiftReminderWrapper = ({ children, headerRight }: Props) => {
  return (
    <div className={wrapper}>
      <div className={headerWrapper}>
        <h1 className={heading}>
          <LargeHeading>Reminders</LargeHeading>
        </h1>
        {headerRight}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default GiftReminderWrapper;
